import { module } from "angular";
import { FilterComponent } from "./FilterComponent";

module("mmGui").component("mmFilter", new FilterComponent());
